require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./apis-and-microservices-managing-packages-with-npm-add-keywords-to-your-package-json.json") })
        }
      }, "path---apis-and-microservices-managing-packages-with-npm-add-keywords-to-your-package-json");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---apis-and-microservices-managing-packages-with-npm-add-keywords-to-your-package-json!./.cache/json/apis-and-microservices-managing-packages-with-npm-add-keywords-to-your-package-json.json
// module id = 1278
// module chunks = 231608221292675